import { publishDsdEditorReviewLoadError } from "@/utils/dsd-editor/review-load-error-channel";
import { useEffect, useRef } from "react";

/**
 * 에디터 페이지가 연 창이면, 로드 실패를 부모 창에 알리고 이 창을 닫는다.
 */
export const useCloseOnReviewLoadError = (
  isError: boolean,
  closeOnLoadError: boolean,
) => {
  const handledRef = useRef(false);

  useEffect(() => {
    if (!closeOnLoadError || !isError) return;
    if (handledRef.current) return;

    handledRef.current = true;
    publishDsdEditorReviewLoadError();

    const timeoutId = window.setTimeout(() => {
      window.close();
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [closeOnLoadError, isError]);
};
